import { useAtom } from "jotai";
import { useMemo } from "react";
import dayjs from "dayjs";
import {
  activeUsersInPeriodQueryAtom,
  clickAnalyticsWithParamsQueryAtom,
  subConditionsCountQueryAtom,
  superConditionsCountQueryAtom,
  usersCountQueryAtom,
} from "../services/queries";

const useDashboardData = () => {
  const currentDate = useMemo(() => dayjs().startOf("D"), []);

  // Users data
  const [{ data: usersCount, isLoading: isUsersCountLoading }] = useAtom(
    usersCountQueryAtom,
    { delay: 1 }
  );

  // Conditions data
  const [{ data: conditionCategoriesCount }] = useAtom(
    superConditionsCountQueryAtom,
    { delay: 1 }
  );
  const [{ data: conditionsCount }] = useAtom(subConditionsCountQueryAtom, {
    delay: 1,
  });

  // Active users data
  const activeUsersInPeriodAtom = useMemo(() => {
    const fromDate = currentDate.clone().subtract(1, "month").toISOString();
    const toDate = currentDate.clone().endOf("day").toISOString();
    return activeUsersInPeriodQueryAtom({ from: fromDate, to: toDate });
  }, [currentDate]);
  const [{ data: activeUsersCountThisMonth }] = useAtom(
    activeUsersInPeriodAtom
  );

  // Guidelines analytics data
  const [{ data: guidelineClickAnalyticsSoFar }] = useAtom(
    useMemo(
      () =>
        clickAnalyticsWithParamsQueryAtom({
          to: currentDate.clone().toISOString(),
        }),
      [currentDate]
    ),
    { delay: 1 }
  );

  const [{ data: guidelineClickAnalyticsToday }] = useAtom(
    useMemo(
      () =>
        clickAnalyticsWithParamsQueryAtom({
          from: currentDate.clone().startOf("day").toISOString(),
          to: dayjs().endOf("D").clone().toISOString(),

        }),
      [currentDate]
    ),
    { delay: 1 }
  );

  return {
    usersCount,
    conditionsCount,
    conditionCategoriesCount,
    activeUsersCountThisMonth,
    guidelinesAccessedSoFar:
      guidelineClickAnalyticsSoFar?.page?.totalElements || 0,
    guidelinesAccessedToday:
      guidelineClickAnalyticsToday?.page?.totalElements || 0,
  };
};

export { useDashboardData };
